define(function(require, exports, module) {
    'use strict';
    const BaseReplacerView = require('common/base.replacer.view');
    const PendingCollection = require('portlets/cashier/pending/pending.collection');

    module.exports = BaseReplacerView.extend({

        accessRules: {
            allow: ['user']
        },

        tagName: 'span',

        initialize: function() {
            this.pendigcollection = new PendingCollection();
        },

        render: function() {
            this._loadPendingCollection();

            return this;
        },

        _loadPendingCollection: function() {
            this.pendigcollection
                .fetch()
                .done(this.success.bind(this))
                .fail(this.fail.bind(this));
        },

        success: function(response) {
            if (response.data.payments) {
                const totalAmount = response.data.payments.transaction.map(el => el.amount).reduce((a, b) => a + b, 0);
                this.$el.html(window.Playtech.API.formatter.formatCurrency(totalAmount));
            } else {
                this.$el.html(window.Playtech.API.formatter.formatCurrency(0));
            }
        },

        fail: function(response) {
            console.error(response.data?.errorMessage);
        }

    }, {
        nameOfReplacers: [
            'PENDING_WITHDRAWALS_COUNT'
        ]
    });
});
